import { httpReducer, reduceReducers } from "../lib/create-action";
import { GET_MY_CARDS, ADD_CARD } from "../action_managers/subscriptions";
const initialProps = {
  cards: {},
};

const getMyCards = httpReducer(GET_MY_CARDS, initialProps, {
  success: (state, action) => ({
    ...state,
    cards: action.payload.resp.reduce((agg, card) => {
      agg[card.id] = card;
      return agg;
    }, {}),
  }),
});

const addCard = httpReducer(ADD_CARD, initialProps, {
  success: (state, action) => ({
    ...state,
    cards: {
      ...state.cards,
      [action.payload.resp.id]: action.payload.resp,
    },
  }),
});

export default reduceReducers(getMyCards, addCard);
